import { faPaw, faUsers } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Navbar.module.scss';
import React from 'react';

interface TagsNavbarProps {
    selectedTab?: 'pets' | 'clients';
    onTabChange: (tab: 'pets' | 'clients') => void;
}

export const TagsNavbar: React.FC<TagsNavbarProps> = ({ selectedTab, onTabChange }) => {
    return (
        <div className={styles.root}>
            <nav className={styles.menu}>
                <div
                    className={styles.menuLink}
                    onClick={() => onTabChange('pets')}
                    aria-current={selectedTab === 'pets' ? 'page' : undefined}
                >
                    <FontAwesomeIcon icon={faPaw} />
                    <span>Pets</span>
                </div>
                <div
                    className={styles.menuLink}
                    onClick={() => onTabChange('clients')}
                    aria-current={selectedTab === 'clients' ? 'page' : undefined}
                >
                    <FontAwesomeIcon icon={faUsers} />
                    <span>Clients</span>
                </div>
            </nav>
        </div>
    );
};
